module.exports = __webpack_public_path__ + "media/images/home/5-a00fc3a39685602b2207b84f311de86d.png";